/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../components/iosSwitchMain";

const SubadminList = () => {

    const navigate = useNavigate();

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    const rows = [
        {
            id: 1,
            email: "david@yopmail.com",
            phone: "9876543210",
            date: "01 March 2025",
            role: "Role 1"
        },
        {
            id: 2,
            email: "david@yopmail.com",
            phone: "9876543210",
            date: "01 March 2025",
            role: "Role 1"
        },
        {
            id: 3,
            email: "david@yopmail.com",
            phone: "9876543210",
            date: "01 March 2025",
            role: "Role 1"
        },
        {
            id: 4,
            email: "david@yopmail.com",
            phone: "9876543210",
            date: "01 March 2025",
            role: "Role 1"
        },
        {
            id: 5,
            email: "david@yopmail.com",
            phone: "9876543210",
            date: "01 March 2025",
            role: "Role 1"
        },
    ];
    const columns: GridColDef<(typeof rows)[number]>[] = [
        {
            flex: 1,
            minWidth: 180,
            field: "name",
            headerName: "Name",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <div className="user_block click_action" onClick={() => navigate("/manage-subadmin/detail")}>
                        <figure>
                            <img src="/static/images/user_placeholder.png" alt="" />
                        </figure>
                        <p><b>David</b></p>
                    </div>
                )
            }
        },
        {
            flex: 1,
            minWidth: 180,
            field: "email",
            headerName: "Email",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 180,
            field: "phone",
            headerName: "Phone Number",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 150,
            field: "role",
            headerName: "Role",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 150,
            field: "date",
            headerName: "Created Date",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 100,
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
                return (
                  <IosSwitchMain />
                )
            }
        },
        {
            minWidth: 130,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <div className="table_actions v2">
                      
                        <Box>
                            <IconButton onClick={() => navigate("/manage-subadmin/add")}>
                                <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton>
                                <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                    </div>
                )
            }
        }
    ];
    let hidden = ["fullName"];

    return (
        <>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={rows}
                />
            </div>
        </>
    );
};

export default SubadminList;
